<div *ngIf="showPreviewPage" class="header-container">
    <h3 class="text-center">{{ pageName }} - Showing ({{ currentLocale }}
        ) {{ currentDate | usanadate: 'short' | async }}</h3>
    <div class="row header-wrapper">
        <div class="input-wrapper">
            <div class="preview-country">
                <label class="page-label">Language:&nbsp;
                    <input class="form-control" type="text" size="4" [(ngModel)]="previewLanguage">
                </label>
                <label class="page-label">Country:&nbsp;
                    <input class="form-control" type="text" size="4" [(ngModel)]="previewCountry">
                </label>
                <div class="body-text-2">(Content may reflect your locale instead of the target one)</div>
            </div>
            <div class="date-picker">
                <label class="page-label">Date/Time:&nbsp;

                    <input type="text"
                           class="form-control"
                           placeholder="Date to view"
                           bsDatepicker
                           [(bsValue)]="previewDate"
                           [placement]="'right'"
                           [bsConfig]="{containerClass: 'theme-default'}">
                </label>
            </div>
            <div class="time-picker">
                <timepicker [(ngModel)]="previewDate"></timepicker>
            </div>
        </div>
        <div class="action-wrapper">
            <div>
                <a class="button button-secondary" (click)="setPreviewPage()">Update Page</a>
            </div>
            <div class="padding-lr-15">
                <a class="button button-secondary " (click)="closePreviewPage()">Close</a>
            </div>
        </div>
    </div>
</div>
